import React, { Component } from 'react'
import { Link } from 'react-router'
import { Sidebar, Message, Icon, Button, Menu, Popup, Segment } from 'semantic-ui-react'

import _ from 'lodash'

import store from 'store'

import { UserApi } from 'trill-api-admin-client'

import LogLevel from '../LogLevel'

import logoLight from '../images/logo-light.png'
import logoDarkToolName from '../images/logo-dark-with-tool-name.png'
import GetPermission from '../GetPermission'

import { SidebarItemsByRole } from '../enums/Sidebar'

import './Main.css'

const userApi = new UserApi()

const logger = LogLevel.getLogger('Main')

const env = {
  development: {
    color: 'green',
    content: '開発環境（DEV）',
  },
  staging: {
    color: 'teal',
    content: 'ステージング環境（STG）',
  },
  production: {
    color: 'red',
    content: '本番環境（PROD）',
  },
  local: {
    color: 'grey',
    content: 'ローカル環境（LOCL）',
  },
}

const commonPathRegex = /^(\/|\/password-update)$/

const SidenavItems = ({ userRole }) => {
  // eslint-disable-line arrow-body-style
  const buildEnv = _.defaultTo(process.env.REACT_APP_BUILD_ENV, 'local')
  const sidebarItems = _.filter(
    _.map(SidebarItemsByRole[userRole], sidebar => ({
      ...sidebar,
      items: _.filter(sidebar.items, item => _.get(GetPermission(item.scope), 'hasReadPermission', false)),
    })),
    sidebar => sidebar.items.length,
  )

  return (
    <div>
      {/* TODO: 仕様が未確定のためコメントアウト */}
      {/* <Link to='/dashboard' className='item' activeClassName='active'>
        <Icon name='dashboard' />
        ダッシュボード
        </Link> */}

      <Segment vertical inverted color={_.get(env, `${buildEnv}.color`)} textAlign="center" size="tiny">
        <b>{_.get(env, `${buildEnv}.content`)}</b>
      </Segment>

      {sidebarItems.map((sidebar, sidebarIndex) => (
        <Menu.Item key={`sidebar_${sidebarIndex}`}>
          <Menu.Header className="Sidenav__SectionHeader">{sidebar.header}</Menu.Header>

          <Menu.Menu>
            {sidebar.items.map((item, itemIndex) => (
              <Menu.Item
                className="Sidenav__SectionItem"
                as={Link}
                to={item.path}
                activeClassName="active"
                key={`sidebar_${sidebarIndex}_item_${itemIndex}`}
              >
                <span>
                  <Icon name={item.icon} />
                </span>
                {item.label}
              </Menu.Item>
            ))}
          </Menu.Menu>
        </Menu.Item>
      ))}
    </div>
  )
}

const ToolbarPopupStyle = {
  padding: '0',
  border: 'none',
  boxShadow: 'none',
}

class Main extends Component {
  state = {
    currentUser: {},
    drawerSidenavVisible: false,
    isPathChanged: false,
  }

  componentDidMount() {
    userApi
      .getCurrentUser()
      .then(response => {
        const user = response.data

        const partialState = { currentUser: { name: user.username, role: user.role } }

        this.setState(partialState)

        const currentUser = { userId: user.id }

        store.set('currentUser', currentUser)
      })
      .catch(error => {
        logger.error('get current user error', error)

        this.setState({
          currentUser: {
            name: 'Anonymous',
            photo: '',
          },
        })
      })
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      isPathChanged: this.props.location.pathname !== nextProps.location.pathname,
    })
  }

  handleSidenavToggleClick = () => {
    this.setState({
      drawerSidenavVisible: !this.state.drawerSidenavVisible,
    })
  }

  handleSignOutClick = () => {
    store.remove('authToken')
    store.remove('currentUser')
  }

  render() {
    const { currentUser, drawerSidenavVisible } = this.state

    const childrenWithProps = React.Children.map(this.props.children, child =>
      React.cloneElement(child, {
        isPathChanged: this.state.isPathChanged,
      }),
    )

    const errorUserAuthorizedMessage = (
      <Message negative icon>
        <Icon name="warning circle" />
        <Message.Content>
          <Message.Header>Forbidden</Message.Header>
          <div>
            権限が再設定されています。一度サインアウトをし、サインインをしてください。解決しない場合は、Slackにてご連絡ください
          </div>
          <div>
            <Button basic size="small" content="サインアウト" icon="sign out" onClick={this.handleSignOutClick} />
          </div>
        </Message.Content>
      </Message>
    )

    const pathname = _.get(this.props, 'location.pathname', '')
    const isArticleDetailPage = pathname.match(/^\/article(\/\d+)?$/g)

    const hasPermissionAccessPath =
      commonPathRegex.test(pathname) ||
      _.some(SidebarItemsByRole[currentUser?.role], sidebar =>
        _.some(sidebar.items, item => _.isRegExp(item.activePathPattern) && item.activePathPattern.test(pathname)),
      )

    return (
      <Sidebar.Pushable className={`Main${isArticleDetailPage ? ' Main--ArticleDetail' : ''}`}>
        {/* ツールバー */}
        <Menu borderless fixed="top" icon className="Main__Toolbar">
          <Menu.Item className="Toolbar__SidenavToggle" onClick={this.handleSidenavToggleClick}>
            <Icon name="sidebar" />
          </Menu.Item>

          <Link to="/" className="Toolbar__Logo item">
            <img src={logoDarkToolName} alt="TRILL管理ツール" className="logo" />
          </Link>

          {currentUser && (
            <Menu.Item className="Toolbar__UserToggle">
              <Popup
                on="click"
                position="bottom right"
                basic
                style={ToolbarPopupStyle}
                trigger={
                  <div className="UserToggle__UserInfo">
                    <Icon name="user" />
                    <span>{currentUser.name}</span>
                    <Icon name="dropdown" />
                  </div>
                }
              >
                <Popup.Content>
                  <Menu vertical borderless>
                    <Menu.Item as="a" href="/password-update">
                      <Icon name="key" />
                      パスワード変更
                    </Menu.Item>
                    <Menu.Item onClick={this.handleSignOutClick}>
                      <Icon name="sign out" />
                      サインアウト
                    </Menu.Item>
                  </Menu>
                </Popup.Content>
              </Popup>
            </Menu.Item>
          )}
        </Menu>

        {/* 常に（スクリーン幅が広い時）表示されるサイドバー */}
        <Menu inverted vertical fixed="left" className="Main__Sidenav">
          <SidenavItems userRole={currentUser.role} />
        </Menu>

        {/* スクリーン幅が狭い時に、ツールバーの切り替えボタンで表示される Drawer 形式のサイドバー */}
        <Sidebar
          as={Menu}
          animation="overlay"
          vertical
          inverted
          visible={drawerSidenavVisible}
          className="Main__DrawerSidenav"
        >
          <Link to="/" className="Toolbar__Logo item">
            <img src={logoLight} alt="TRILL" />
          </Link>

          <SidenavItems userRole={currentUser.role} />
        </Sidebar>

        {/* コンテンツ領域 */}
        <Sidebar.Pusher className="Main__Content" dimmed={drawerSidenavVisible}>
          {!_.isEmpty(currentUser) && (
            <div className="Main__ContentContainer">
              {/* 中身はルーティングで切り替え */}
              {hasPermissionAccessPath ? childrenWithProps : errorUserAuthorizedMessage}
            </div>
          )}
        </Sidebar.Pusher>

        <div className="Main__ContentDimmerArea" onClick={this.handleSidenavToggleClick} />
      </Sidebar.Pushable>
    )
  }
}

export default Main
